export default "__VITE_ASSET__B2ut$ynp__"